/* 88 Acres · content-88.js
   1. Article: "Copy link" button (data-copy-88) with a polite status message.
   2. Page: builds the "On this page" list from the page's H2s (3 or more), adding ids where missing.
   3. Careers: loads open roles from the Paylocity jobs feed (data-jobs-88) and renders them with
      textContent only (feed text is never inserted as HTML). */
(function () {
  function slug(text, used) {
    var base = (text || 'section').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'section';
    var id = base, n = 2;
    while (used[id] || document.getElementById(id)) { id = base + '-' + n++; }
    used[id] = true;
    return id;
  }

  function initToc() {
    document.querySelectorAll('[data-toc-88]').forEach(function (nav) {
      if (nav.dataset.ready) return;
      nav.dataset.ready = '1';
      var source = nav.parentElement.querySelector('[data-toc-source-88]');
      if (!source) return;
      var heads = source.querySelectorAll('h2');
      if (heads.length < 3) return;
      var list = nav.querySelector('ul');
      var used = {};
      heads.forEach(function (h) {
        var label = h.textContent.trim();
        if (!label) return;
        if (!h.id) h.id = slug(label, used);
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = label.charAt(0) + label.slice(1).toLowerCase();
        li.appendChild(a);
        list.appendChild(li);
      });
      nav.hidden = false;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-copy-88]');
    if (!btn) return;
    var url = btn.getAttribute('data-copy-88');
    var status = btn.parentElement.querySelector('[data-copy-status-88]');
    var done = function () { if (status) status.textContent = btn.getAttribute('data-copied-88') || 'Link copied'; };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done, done);
    } else {
      done();
    }
  });

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text) n.textContent = text;
    return n;
  }

  function safeUrl(u) {
    try {
      var url = new URL(u, location.href);
      return url.protocol === 'https:' ? url.href : '';
    } catch (err) { return ''; }
  }

  function initJobs() {
    document.querySelectorAll('[data-jobs-88]').forEach(function (box) {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      var feed = box.getAttribute('data-jobs-88');
      var apply = box.getAttribute('data-apply-88') || 'View and apply';
      var setStatus = function (msg) {
        box.textContent = '';
        box.appendChild(el('p', 'jb88-status', msg));
      };
      if (!feed) { setStatus(box.getAttribute('data-empty-88')); return; }
      fetch(feed, { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (data) {
          var jobs = (data && (data.jobs || data)) || [];
          if (!Array.isArray(jobs) || jobs.length === 0) { setStatus(box.getAttribute('data-empty-88')); return; }
          box.textContent = '';
          jobs.forEach(function (job) {
            var title = job.title || job.jobTitle || job.positionTitle || job.name || '';
            var loc = job.jobLocation || {};
            var where = loc.locationDisplayName || [loc.city, loc.state].filter(Boolean).join(', ');
            var link = safeUrl(job.displayUrl || job.applyUrl || '');
            var card = el('div', 'jb88-job');
            var text = el('div');
            text.appendChild(el('h3', 't-h3', title));
            if (where) text.appendChild(el('p', null, where));
            card.appendChild(text);
            if (link) {
              var a = el('a', 'btn-88 btn-88--secondary', apply);
              a.href = link;
              a.target = '_blank';
              a.rel = 'noopener';
              var sr = el('span', 'vh-88', ': ' + title + ' (opens in a new tab)');
              a.appendChild(sr);
              card.appendChild(a);
            }
            box.appendChild(card);
          });
        })
        .catch(function () { setStatus(box.getAttribute('data-error-88')); });
    });
  }

  function init() { initToc(); initJobs(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
